import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay/legacy';

import {
    REGULAR_MODULE_TYPE,
    BANNER_MODULE_TYPE,
    BANNER_TILES_MODULE_TYPE,
    CREATOR_MODULE_TYPE,
} from '../../constants/contentModuleConstants';

import { SbRespContentModuleRegular } from '../SbRespContentModuleRegular/SbRespContentModuleRegular';
import { SbSharedContentModuleBanner } from '../SbSharedContentModuleBanner/SbSharedContentModuleBanner';
import { SbSharedContentModuleBannerTiles } from '../SbSharedContentModuleBannerTiles/SbSharedContentModuleBannerTiles';
import { SbRespContentModuleCreator } from '../SbRespContentModuleCreator/SbRespContentModuleCreator';

const SbRespContentModuleSelectorComponent = ({ itemSearch }) => {
    const { browseContentModule } = itemSearch;

    if (!browseContentModule) {
        return null;
    }

    switch (browseContentModule.moduleType) {
        case REGULAR_MODULE_TYPE:
            return <SbRespContentModuleRegular browseContentModule={browseContentModule} />;
        case BANNER_MODULE_TYPE:
            return (
                <SbSharedContentModuleBanner
                    browseContentModule={browseContentModule}
                    renderImage={({ src, imgClassName, alt }) => (
                        <img src={src} className={imgClassName} alt={alt} />
                    )}
                />
            );
        case BANNER_TILES_MODULE_TYPE:
            return <SbSharedContentModuleBannerTiles browseContentModule={browseContentModule} />;
        case CREATOR_MODULE_TYPE:
            return <SbRespContentModuleCreator browseContentModule={browseContentModule} />;
        default:
            return null;
    }
};

SbRespContentModuleSelectorComponent.propTypes = {
    itemSearch: PropTypes.object.isRequired,
};

export const SbRespContentModuleSelector = createFragmentContainer(
    SbRespContentModuleSelectorComponent,
    {
        itemSearch: graphql`
            fragment SbRespContentModuleSelector_itemSearch on ItemSearchQueryConnection {
                browseContentModule(contentModuleId: $contentModuleId) {
                    moduleType
                    ...SbRespContentModuleRegular_browseContentModule
                    ...SbSharedContentModuleBanner_browseContentModule
                    ...SbSharedContentModuleIconicDesign_browseContentModule
                    ...SbSharedContentModuleBannerTiles_browseContentModule
                    ...SbRespContentModuleCreator_browseContentModule
                }
            }
        `,
    }
);
